export const useServicesStore = () => {
    const init = () => {
        window.Alpine.store("services", {
            sportsBook: {
                created: false,
                initialized: false,
                loaded: false,
            },
            sportsBookV2: {
                created: false,
                initialized: false,
                loaded: false,
            },
        });
    };
    return { init };
};
